import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {AiPrompt, AiPromptUsage} from 'app/Model/aiprompt';
import { AiPromptsService } from 'app/Services/aiprompt.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { LoginService } from 'app/Services/login.service';
import { UpdateTemplateService } from 'app/Services/updateTemplate.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SelectionChangedEvent, ValueChangedEvent } from 'devextreme/ui/select_box';
import { TemplateItemTemplate } from '../../../Model/Catalog/TemplateItemTemplate';
import { ArrayStore, DataSource } from 'devextreme/common/data';
import {NextPimField} from 'app/Model/Catalog/NextPimField';
import {fieldNames, FieldNames} from "../../../Model/FieldNames";
import {FieldListInterface} from "../../../Model/ui/FieldListInterface";
@Component({
    selector: 'aiprompt-editor',
    templateUrl: './aiprompt-editor.component.html',
    standalone: false
})
export class AipromptEditorComponent implements OnInit {
  @Input() prompt: AiPrompt = new AiPrompt();
  @Output() promptChange = new EventEmitter<string>();

  models: { model: string; provider: string; isSystemProvided: boolean }[] = [];
  shownModels: { model: string; provider: string; isSystemProvided: boolean }[] = [];
  selectedModel: { model: string; provider: string; isSystemProvided: boolean };

  selectedTemplateItemField;
  fields : {field:  string, group: string, translation:string}[] =[];
  storeFields: { field: string, group: string, translation: string }[] = [];
  fieldGroups : {key: string, items: string[]}[] = [];

  dataSource;
  mimeFields: { field: string, group: string, translation: string } [] = [{
    field: fieldNames.mimeImage,
    group: "Mimes",
    translation: ""
  },
    {field: fieldNames.mimeDescription, group: "Mimes", translation: ""}];
  mimePimField = new NextPimField('-1', '1', undefined, false, false, 'mime');

  availableGroups: string[] = [];
  targetFieldsContainer: FieldListInterface = { fields: [] };
  targetFieldsLoading: boolean;
  promptUsageOptions = [
        { value: AiPromptUsage.ProductLayer, label: this.translate.instant('Massendatenänderung und Produktebene') },
        { value: AiPromptUsage.Template, label: this.translate.instant('Experten-Template-Editor') }
    ];
  protected readonly parseInt = parseInt;
  protected readonly fieldNames = fieldNames;

  get featureSystemField(): NextPimField | undefined {
    return this.prompt.nextPimTargetFields?.find(f => f.field === fieldNames.fillFeatureSystem);
  }

  get mimeDescriptionFilter() {
    if (this.mimePimField.elementKey == '-1')
      return '';
    return this.mimePimField.elementKey;
  }

  set mimeDescriptionFilter(value: string) {
    this.mimePimField.elementKey = value?.trim() ? value : '-1';
  }
  constructor(
    public aiPromptsService: AiPromptsService,
    public loginService: LoginService,
    public translate: TranslateService,
    public updateTemplateService: UpdateTemplateService,
    public catalogService: CatalogService
  ) {}

  async ngOnInit() {
    this.targetFieldsLoading = true;
    this.aiPromptsService.getModels(this.loginService.currentCustomer.id).then(x=>{
      this.models = x;
      this.shownModels = this.models;
      this.selectedModel = this.shownModels.find((x) => x.provider == this.prompt.provider && x.model == this.prompt.model);
      this.filterModelsAbleToSearchTheWeb();
    });

    this.fields = await this.aiPromptsService.getFieldsWithGroups(this.loginService.currentCustomer.id) as any;
    
    this.mimeFields.forEach((x) => {
      x.translation = this.translate.instant(x.field);
    });
    if(this.prompt.useDocumentExtraction){
        this.storeFields = [...this.mimeFields, ...this.fields];
        this.refreshDataSource();
    }
    else {
        this.storeFields = [...this.fields];
    }

     this.dataSource = new DataSource({
      store: new ArrayStore({
        data: this.storeFields,
        key: 'field',
      }),
      group: 'group',
    });
    this.initTargetFields();
  }

  isMimeField(): boolean {
    return (this.selectedTemplateItemField?.group ?? "") == "Mimes";
  }

  onMimeNumberForMarkupChange(event: any) {
    const value = parseInt(event.value);
    this.mimePimField.systemKey = isNaN(value) || value <= 0 ? '1' : value.toString();
  }

  addMimeOptionsToFields() {
    this.storeFields = [...this.mimeFields, ...this.fields];
    this.refreshDataSource();
  }

  refreshDataSource() {
    this.dataSource = new DataSource({
      store: new ArrayStore({
        data: this.storeFields,
        key: 'field',
      }),
      group: 'group',
    });
  }
     
  

  initTargetFields() {
    this.availableGroups = [...new Set(this.fields.map(f => (f as any).group))];
    this.targetFieldsContainer.fields = (this.prompt.nextPimTargetFields ?? []).map(f => f.field);

    this.fields.forEach((x) => {
      x.translation = this.translate.instant(x.field);
    });

    this.targetFieldsLoading = false;
  }

  onTargetFieldsChanged() {
    const existing = new Map((this.prompt.nextPimTargetFields ?? []).map(f => [f.field, f]));
    this.prompt.nextPimTargetFields = this.targetFieldsContainer.fields.map(
      field => existing.get(field) ?? new NextPimField(undefined, undefined, field)
    );
  }

  removeimeOptionsToFields() {
    this.storeFields = [...this.fields];
    this.refreshDataSource();
  }

  onModelChanged(e: ValueChangedEvent) {
    if (e.value) {
      this.prompt.model = e.value.model;
      this.prompt.provider = e.value.provider;
    }
  }

  onDocumentExtractionChanged(e: ValueChangedEvent) {
    if (e.value) {
      this.addMimeOptionsToFields();
    } else {
      this.removeimeOptionsToFields();
    }
  }

  displayExprFn(item: any) {
    if (!item) return '';
    return `${item.provider} | ${item.model}`;
  }

  generatePlaceholder() {
    this.prompt.prompt ??= "";   
    if (this.selectedTemplateItemField.group == "Mimes") {
      const { systemKey, elementKey, useSequence } = this.mimePimField;
      this.prompt.prompt +=
        '[' + this.selectedTemplateItemField.field +
        '__' + systemKey +
        '__' + elementKey +
        '__' + (useSequence ? 'SEQ' : 'ORD') + ']';
    } else {
    this.prompt.prompt += '[' + this.selectedTemplateItemField.field + ']';    
  }
  
  }
  
  filterModelsAbleToSearchTheWeb() {
    if (this.prompt.loadURLsLive) {
      this.shownModels = this.models.filter((x) => !x.isSystemProvided);
      if (!this.shownModels.some(x => x.model == this.selectedModel.model)) {
        this.selectedModel = null;
      }
    } else {
      this.shownModels = this.models;
    }
  }

}
